import { FilterTextItem } from '../filter.text.item';

export const GUID_FILTER = new FilterTextItem({
  labelKey: 'common:field:guid',
  field: 'guid',
});